// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bx-b";
export var colorBlue = "_bx-8";
export var colorDot = "_bx-0";
export var colorDotLarge = "_bx-2";
export var colorDotSmall = "_bx-1";
export var colorGreen = "_bx-7";
export var colorGrey = "_bx-3";
export var colorOrange = "_bx-5";
export var colorPink = "_bx-a";
export var colorPurple = "_bx-9";
export var colorRed = "_bx-4";
export var colorYellow = "_bx-6";